import * as React from 'react';
import { SVGProps } from 'react';

const IconBagSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 8V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v.834L14.144 14.39a.5.5 0 0 1-.288 0L2 10.834V10a2 2 0 0 1 2-2h3Zm3 0V6h8v2h-8Z"
    />
    <path d="M15.006 17.264 26 13.966V23a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9.034l10.994 3.298a3.5 3.5 0 0 0 2.012 0Z" />
  </svg>
);
export default IconBagSizeL;
